import api from '@/apis/di/budgetItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex';
import { ModuleBudgetItem } from '@/stores/moduleConst';
import { MSConstant } from '@/commons/wildcards/index.js';

// Combo grid Mục
export const useBudgetSubItemComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetSubItemComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [
      {
        Field: 'budget_item_type',
        Value: proxy.$ms.constant.BudgetItemType.SubItem,
      },
      { Field: 'inactive', Value: false, Ors: ors },
    ];

    if (payload.columns && !payload.columns.includes('misa_code_id')) {
      payload.columns += ',misa_code_id';
    }
    if (payload.columns && !payload.columns.includes('budget_group_item_code')) {
      payload.columns += ',budget_group_item_code';
    }

    payload.sort = 'budget_item_code';
    payload.filter = extendFilter(payload.filter, extend); // 3 Là tiểu mục
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const budgetSubItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã tiểu mục',
        dataField: 'budget_item_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tiểu mục',
        dataField: 'budget_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'budget_item_code',
    valueField: 'budget_item_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    quickSearch: 'BudgetItemQuickSearch',
    quickSearchParam: {
      titleSearch: 'Tìm nhanh tiểu mục',
      isFilter: true,
      filterFunc: x => !x.inactive && x.budget_item_type == 3,
    },
    comboboxLoadData: onBudgetSubItemComboboxLoadData,
    modelValueField: 'budget_sub_item_code',
  };

  // const store = useStore();
  // const budgetItems = store.getters[`${ModuleBudgetItem}/items`];

  // const budgetSubItemDataCombo = computed(() => {
  //   return budgetItems.filter(
  //     x => !x.inactive && x.budget_item_type === MSConstant.BudgetItemType.SubItem
  //   );
  // });
  // comboboxDataRemote['budget_sub_item_code'] = budgetSubItemDataCombo;
  // Sự kiện load combo trên grid
  return {
    budgetSubItemComboConfig,
    onBudgetSubItemComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
